import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Upload,
  Col,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Filter from "./../../../components/Filter";
import { useSelector } from "react-redux";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import UploadProfilePicture from "../../../components/UploadProfilePicture";
function AdminsList() {
  const [form] = Form.useForm();
  const [imageUrl, setImageUrl] = useState("");
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [adminList, setAdminList] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [pharmacies, setPharmacies] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    pharmacyId: null,
    status: null,
    search: null,
  });
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filterDropdowns, setFilterDropdowns] = useState([
    {
      title: "Status",
      options: ["Active", "Inactive"],
    },
  ]);
  const [modalData, setModalData] = useState();
  const fetchAdmin = async (
    page = 1,
    pageSize = 10,
    search = null,
    status = null
  ) => {
    setLoading(true);
    try {
      // Build query parameters dynamically
      const queryParams = new URLSearchParams({
        limit: pageSize,
        page: page,
        ...(search && { search }),
        ...(status !== null && { active: status }),
      }).toString();

      const response = await axios.get(`${API_URL}users/get-users?role[]=1&${queryParams}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { users, totalCount } = response.data;
      setAdminList(users);
      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize: pageSize,
        total: totalCount,
      }));
    } catch (error) {
      console.error("Error fetching admins:", error);
      message.error("Failed to fetch admins");
    } finally {
      setLoading(false);
    }
  };
  const handleViewPharmacies = (row) => {
    setIsEdit(true);
    // Make a copy of the row data to avoid reference issues
    const rowCopy = JSON.parse(JSON.stringify(row));

    // Ensure dates are properly formatted
    if (rowCopy.userDetails && rowCopy.userDetails.dob) {
      // Store the original date string for comparison
      rowCopy.userDetails.originalDob = rowCopy.userDetails.dob;
    }

    setModalData(rowCopy);
    setIsModalVisible(true);
  };

  useEffect(() => {
    fetchAdmin();
  }, []);
  useEffect(() => {
    if (modalData && modalData.userDetails) {
      const userDetails = modalData.userDetails;
      form.setFieldsValue({
        firstName: userDetails.firstName || "",
        lastName: userDetails.lastName || "",
        gender: userDetails.gender || "",
        dob: userDetails.dob ? moment(userDetails.dob) : null,
        nationality: userDetails.nationality || "",
        Height: userDetails.Height || "",
        Weight: userDetails.Weight || "",
        position: userDetails.position || "",
        mobileNumber: modalData.mobileNumber || "",
        profilePicture: modalData.userDetails.profilePicture || "",
      });

      // Set up form change listener
      const unsubscribe = form.getFieldsValue(['dob']);

      form.setFields([
        {
          name: 'dob',
          touched: false,
        }
      ]);
    } else {
      form.resetFields();
    }
  }, [modalData, form, isModalVisible]);
  const handleSave = async (values) => {
    // Force a direct update if there's a date
    let hasDateChanged = false;
    if (isEdit && modalData && modalData.userDetails) {
      // Get the original DOB string from modalData
      const originalDob = modalData.userDetails.originalDob || modalData.userDetails.dob;
      // Get the new DOB as a string
      const newDob = values.dob ? moment(values.dob).format("YYYY-MM-DD") : null;

      // Simple string comparison
      if (originalDob !== newDob) {
        hasDateChanged = true;
      }
    }

    const dobFormatted = values.dob
      ? moment(values.dob).format("YYYY-MM-DD")
      : null;

    // Create a base payload with all possible fields
    const basePayload = {
      firstName: values.firstName,
      lastName: values.lastName,
      gender: values.gender?.toLowerCase(),
      dob: dobFormatted,
      nationality: values.nationality,
      Height: Number(values.Height),
      Weight: Number(values.Weight),
    };

    // For new admin creation, include all fields
    if (!isEdit) {
      let payload = { ...basePayload };
      if (values.mobileNumber) {
        payload.mobileNumber = values.mobileNumber;
        payload.role = 1;
      }
      if (values.profilePicture) {
        payload.profilePicture = values.profilePicture;
      }

      try {
        const response = await axios.post(`${API_URL}users`, payload, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        message.success("Admin created successfully");
        setIsModalVisible(false);
        form.resetFields();
        fetchAdmin();
      } catch (error) {
        console.error("Error creating admin:", error);
        message.error(`Failed to create admin ${error.response?.data?.message || ""}`);
      }
      return;
    }

    // For editing, only include changed fields
    let payload = {};
    const currentData = modalData.userDetails;

    // Format current DOB for comparison
    const currentDob = currentData.dob ? moment(currentData.dob).format("YYYY-MM-DD") : null;

    // Compare each field with its current value
    if (basePayload.firstName !== currentData.firstName) {
      payload.firstName = basePayload.firstName;
    }
    if (basePayload.lastName !== currentData.lastName) {
      payload.lastName = basePayload.lastName;
    }
    if (basePayload.gender !== currentData.gender?.toLowerCase()) {
      payload.gender = basePayload.gender;
    }

    // Always include DOB if hasDateChanged is true
    if (hasDateChanged) {
      payload.dob = dobFormatted;
    }
    // Otherwise use the standard comparison
    else if (dobFormatted !== currentDob) {
      payload.dob = dobFormatted;
    }

    if (basePayload.nationality !== currentData.nationality) {
      payload.nationality = basePayload.nationality;
    }
    if (basePayload.Height !== Number(currentData.Height)) {
      payload.Height = basePayload.Height;
    }
    if (basePayload.Weight !== Number(currentData.Weight)) {
      payload.Weight = basePayload.Weight;
    }
    if (values.profilePicture && values.profilePicture !== currentData.profilePicture) {
      payload.profilePicture = values.profilePicture;
    }

    // If no fields were changed, show a message and return
    if (Object.keys(payload).length === 0) {
      // Last ditch effort: Check if the datepicker was interacted with
      const dateFieldValue = form.getFieldValue('dob');
      if (dateFieldValue) {
        const formattedDate = moment(dateFieldValue).format("YYYY-MM-DD");

        // If there's any interaction with the date field, include it in the payload
        payload.dob = formattedDate;
      } else {
        message.info("No changes detected. Please modify a field before saving.");
        return;
      }
    }

    try {
      const response = await axios.patch(
        `${API_URL}UserProfiles?id=${modalData.id}`,
        payload,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      message.success("Admin updated successfully");
      setIsModalVisible(false);
      form.resetFields();
      fetchAdmin();
    } catch (error) {
      console.error("Error updating admin:", error);
      message.error(`Failed to update admin ${error.response?.data?.message || ""}`);
    }
  };
  const handleStatusChange = async (id, isActive) => {
    const status = isActive ? 1 : 0;
    try {
      const response = await axios.patch(
        `${API_URL}Users/?id=${id}`,
        { active: status },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        message.success("Status updated successfully");
        fetchAdmin();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${API_URL}users?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 200) {
        message.success("Admin deleted successfully");
        fetchAdmin();
      }
    } catch (error) {
      console.error("Error deleting Admin:", error);
      message.destroy();
      message.error("Failed to delete Admin");
    }
  };
  const handleFilterChange = (key, value) => {
    let updatedFilters = { ...selectedFilters };
    let errorMessageShown = false;

    if (key === "Pharmacy") {
      const pharmacyId = value
        ? pharmacies.find((ph) => ph.name === value)?.id
        : null;
      updatedFilters.pharmacyId = pharmacyId;
    }

    if (key === "Status") {
      const status = value === "Active" ? 1 : value === "Inactive" ? 0 : null;
      updatedFilters.status = status;
    }

    if (key === "search") {
      let search = null;

      if (value && value.trim().length > 0) {
        const searchValue = parseInt(value, 10);

        if (isNaN(searchValue)) {
          message.destroy();
          message.error("Search term must be a valid number.");
          errorMessageShown = true;
        } else if (value.length > 4) {
          search = searchValue;
        }
      }

      updatedFilters.search = search;
    }

    if (key === "") {
      fetchAdmin();
      updatedFilters = {};
    }

    setSelectedFilters(updatedFilters);

    fetchAdmin(
      1,
      pagination.pageSize,
      updatedFilters.search,
      updatedFilters.status
    );
  };
  const columns = [
    {
      title: <span>Admin Name</span>,
      dataIndex: "userDetails",
      key: "AdminName",
      render: (userDetails) => {
        const firstName = userDetails?.firstName || "";
        const lastName = userDetails?.lastName || "";
        return firstName || lastName ? `${firstName} ${lastName}` : "";
      },
    },
    {
      title: "Contact",
      dataIndex: "mobileNumber",
      key: "Contact",
    },
    {
      title: "Profile",
      render: (text, row) => (
        <Button
          style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
          onClick={() => handleViewPharmacies(row)}
        >
          View
        </Button>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text, row) => (
        <div className="flex">
          <Button
            disabled={row.active}
            style={{
              borderRadius: 0,
              border: 0,
              margin: 0,
              backgroundColor: row.active ? "#3371EB" : "#F7F8FF",
              color: row.active ? "#FFFFFF" : "#123288",
              cursor: row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, true, row.mobileNumber)} // Active button click
          >
            Active
          </Button>
          <Button
            disabled={!row.active}
            style={{
              borderRadius: 0,
              margin: 0,
              border: 0,
              backgroundColor: row.active ? "#F7F8FF" : "#3371EB",
              color: row.active ? "#123288" : "#FFFFFF",
              cursor: !row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, false)} // Inactive button click
          >
            Inactive
          </Button>
        </div>
      ),
    },
    {
      title: "Delete",
      key: "delete",
      render: (text, row) => (
        <Button
          danger
          style={{
            borderRadius: 0,
            borderColor: "#FF4D4F",
            backgroundColor: "#FF4D4F",
            color: "#FFFFFF",
          }}
          onClick={() => handleDelete(row.id)}
        >
          Delete
        </Button>
      ),
    },
  ];
  const handleModalClose = () => {
    setIsModalVisible(false);
    setModalData(null);
    form.resetFields();
    setIsEdit(false);
  };
  const [filterOptions, setFilterOptions] = useState({});

  const showCreateAdminPopup = () => {
    setModalData({
      adminDetails: {
        userDetails: {
          firstName: "",
          lastName: "",
          gender: "",
          dob: "",
          nationality: "",
          Height: "",
          Weight: "",
          profilePicture: "",
          position: "",
        },
      },
    });
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleTableChange = (paginationData, filters, sorter) => {
    fetchAdmin(
      paginationData.current,
      paginationData.pageSize,
      selectedFilters.search,
      selectedFilters.status
    );
  };

  return (
    <>
      <Modal
        title={isEdit ? "Edit Admin" : "Add Admin"}
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        width="90%"
        style={{ maxWidth: "800px" }}
        bodyStyle={{ padding: "20px" }}
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} className="flex justify-center items-center">
              <div className="w-full flex flex-col items-center">
                <UploadProfilePicture
                  value={
                    isEdit
                      ? modalData?.userDetails?.profilePicture || ""
                      : imageUrl
                  }
                  onChange={(url) => {
                    setImageUrl(url);
                  }}
                />
              </div>
            </Col>
            <Col xs={24} md={12}>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                      { required: true, message: "Please enter first name" },
                    ]}
                  >
                    <Input className="w-full h-10" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[
                      { required: true, message: "Please enter last name" },
                    ]}
                  >
                    <Input className="w-full h-10" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Gender"
                    name="gender"
                    rules={[{ required: true, message: "Please select gender" }]}
                  >
                    <Select className="w-full h-10">
                      <Select.Option value="MALE">Male</Select.Option>
                      <Select.Option value="FEMALE">Female</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Date of Birth"
                    name="dob"
                    rules={[
                      { required: true, message: "Please select date of birth" },
                    ]}
                  >
                    <DatePicker className="w-full h-10" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Nationality"
                    name="nationality"
                    rules={[
                      { required: true, message: "Please enter nationality" },
                    ]}
                  >
                    <Input className="w-full h-10" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Contact Number"
                    name="mobileNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter contact number",
                      },
                      {
                        pattern: /^[0-9]{11}$/,
                        message: "Phone number must be exactly 11 digits",
                      },
                    ]}
                  >
                    <Input className="w-full h-10" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Height (cm)"
                    name="Height"
                    rules={[{ required: true, message: "Please enter height" }]}
                  >
                    <Input className="w-full h-10" type="number" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Weight (kg)"
                    name="Weight"
                    rules={[{ required: true, message: "Please enter weight" }]}
                  >
                    <Input className="w-full h-10" type="number" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Form.Item
                    label="Position"
                    name="position"
                    rules={[{ required: true, message: "Please enter position" }]}
                  >
                    <Input className="w-full h-10" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="mt-4">
                <Col xs={24} className="flex justify-end">
                  <Button
                    onClick={handleModalClose}
                    className="mr-2 h-10 px-6"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="h-10 px-6"
                  >
                    {isEdit ? "Update" : "Create"}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Modal>

      <div className="p-4 md:p-6 lg:p-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 md:mb-6">
          <h1 className="text-xl md:text-2xl font-bold mb-2 sm:mb-0">Admins List</h1>
          <Button
            type="primary"
            onClick={showCreateAdminPopup}
            className="h-10 px-4 md:px-6"
          >
            + Add Admin
          </Button>
        </div>

        <div className="bg-white p-4 md:p-6 rounded shadow-sm overflow-x-auto">
          <div className="flex flex-col sm:flex-row mb-4 md:mb-6 gap-2 sm:gap-4">
            <Filter
              options={filterDropdowns}
              onChange={handleFilterChange}
              className="w-full sm:w-auto"
            />
            <div className="w-full sm:w-auto mt-2 sm:mt-0">
              <Input.Search
                placeholder="Search by name"
                allowClear
                onSearch={(value) => handleFilterChange("search", value)}
                style={{ width: '100%' }}
                className="h-10"
              />
            </div>
          </div>

          <Table
            dataSource={adminList}
            columns={columns}
            rowKey={(record) => record.id}
            pagination={pagination}
            onChange={handleTableChange}
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
      </div>
      <Outlet />
    </>
  );
}

export default AdminsList;
